import React from "react";
import AsyncSelect from "react-select/async";
import UserService from "../services/user.service";
import type { ClientSummary } from "../pages/models";

type ClientAutocompleteProps = {
  value: ClientSummary | null;
  onChange: (client: ClientSummary | null) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
  placeholder?: string;
  name?: string;
};

const selectStyles = {
  menu: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 50,
  }),
};

const ClientAutocomplete = ({
  value,
  onChange,
  onBlur,
  isDisabled,
  placeholder,
  name,
}: ClientAutocompleteProps) => {
  const loadOptions = async (inputValue: string): Promise<ClientSummary[]> => {
    if (!inputValue) {
      // Return empty or fetch default initial clients
      return [];
    }
    try {
      const response = await UserService.searchClients(inputValue);
      const data = response.data.data || response.data.results || response.data;
      return Array.isArray(data) ? (data as ClientSummary[]) : [];
    } catch (error) {
      console.error("Error fetching clients", error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      styles={selectStyles}
      getOptionLabel={(option) =>
        option.clientName ||
        (option as ClientSummary & { client_name?: string }).client_name ||
        "Unnamed client"
      }
      getOptionValue={(option) => option.id || ""}
      value={value}
      onChange={onChange}
      onBlur={() => onBlur?.()}
      isDisabled={isDisabled}
      placeholder={placeholder}
      name={name}
      isClearable
    />
  );
};

export default ClientAutocomplete;
